export const CARRIER_OPTIONS = [
  { value: "SKT", label: "SKT" },
  { value: "KT", label: "KT" },
  { value: "LGU", label: "LG U+" },
  { value: "알뜰폰", label: "알뜰폰" },
];
